module.exports = __webpack_public_path__ + "img/salary.1ba87f1d.svg";